<template>
  <b-card
    class="text-center"
  >
  <b-card-title>{{ title }}</b-card-title>
    <b-card-body>
      <!-- <div v-show="!ready" class="text-center">
        <b-spinner label="Loading..." variant="primary"></b-spinner>
        <p>Loading..</p>
      </div> -->
      <load-page v-show="!ready"></load-page>
      
      <vue-apex-charts
        v-show="ready"
        ref="chart"
        type="line"
        height="300"
        :options="chartOptions"
        :series="[]"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCardBody,
  BCardTitle,
  BCard,
  BSpinner
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import LoadPage from '@/views/pages/utils/LoadPage.vue'
import moment from 'moment'

export default {
  components: {
    LoadPage,
    BCardBody,
    BCardTitle,
    BSpinner,
    BCardActions,
    BCard,
    VueApexCharts: () => import('vue-apexcharts'),
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    ready: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rangePicker: ['2023-07-01', '2023-07-05'],
      sensorList: [],
      showGraph: true,
      chartOptions: {
        noData: {
          text: '데이터가 존재하지 않습니다.',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: 'green',
            fontSize: '1.2rem',
            fontFamily: ''
          }
        },
        colors: ['#DC143C', '#1E90FF', '#00ffff', '#7B68EE'],
        chart: {
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 750
            }
          },
          toolbar: {
                show: true
              },
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          
        },
        xaxis: {
          labels: {
            format: 'd일/HH시',
          },
          type: 'datetime',
        },
        tooltip: {
          x: {
            format: 'MM-dd HH:mm'
          }
        },
        markers: {
          strokeWidth: 2,
          strokeOpacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          curve: 'smooth',
        },
       
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
      },
    }
  },
  mounted() {
    
  },
  computed: {

  },
  created() {
  },
  methods: {
    updateUI(sensor) {
      if(sensor.type === 'temperature') {

      }
      else if(sensor.type === 'humidity') {
        this.chartOptions.colors.shift()
      }
      else {
        this.chartOptions.colors.shift()
        this.chartOptions.colors.shift()
      }

      const series = []
      const xydata = []
      series.push({
        name: `${sensor.name}`,
        data: xydata,
      })
      for(let val of sensor.values) {
        if(sensor.type === 'wfs_qubics') {
          val.value = (val.value / 1000).toFixed(1)
        }
        xydata.push({
          x: moment(new Date(val.timestamp).getTime() + 32400000).format('YYYY-MM-DD HH:mm:ss'),
          y: `${val.value}`,
        })
      }
      this.$nextTick(() => {
        this.$refs.chart.updateSeries(series)
      })
      
      
    },
  },
}
</script>
